<button
  [showDelay]="TOOLTIP_DEFAULT_DELAY"
  (click)="menu.toggle($event)"
  class="flx-ds ml-1.5"
  flxButton
  pTooltip="Account"
  tooltipPosition="bottom"
  type="button"
  data-testid="account-menu-button"
  aria-label="Account"
>
  {{ currentUser().initials | uppercase }}
</button>

<p-menu
  #menu
  [popup]="true"
  [model]="menuItems()"
  (onShow)="refreshOrganisationPermissions()"
  styleClass="flx-prime-menu dark account-menu-popup"
  appendTo="body"
>
  <ng-template #start>
    <div class="flex items-center gap-2 px-2 pt-1.5 pb-2.5">
      <span
        class="flex shrink-0 justify-center items-center size-7 rounded-full bg-yellow-500 text-[11px] font-bold text-neutral-900"
        aria-hidden="true"
      >
        {{ currentUser().initials | uppercase }}
      </span>
      <div class="flex flex-col gap-0.5 min-w-0 text-xs">
        <span
          class="truncate font-semibold text-white"
          data-testId="current-name"
          >{{ currentUser().name }}</span
        >
        @if (currentUser().email) {
          <span
            class="truncate text-neutral-300"
            data-testId="current-email"
            >{{ currentUser().email }}</span
          >
        }
      </div>
    </div>
    <div
      class="h-px mx-1 mb-1.5 bg-neutral-500"
      aria-hidden="true"
    ></div>
  </ng-template>
</p-menu>
